<div class="name-container">
    <!-- <smart-icon icon=></smart-icon> -->
    <img [src]="src">
    <div [title]="item.name+item.extension">{{item.name}}{{item.extension}}</div>
</div>